import { Colors, Lightning, Registry } from '@lightningjs/sdk';
import TextLabel from 'components/common/TextLabel';
import { formatVideoTime, getVideoTimeTts } from 'support/contentUtils';
import { translate } from 'support/translate';

const FONT_SIZE = 29;
const ANNOUNCE_DELAY = 500;

interface AdCountdownTemplateSpec extends Lightning.Component.TemplateSpec {
  countdown: number;
  isPreroll: boolean;

  AdCount: typeof TextLabel;
  Countdown: typeof TextLabel;
}

export default class AdCountdown
  extends Lightning.Component<AdCountdownTemplateSpec>
  implements Lightning.Component.ImplementTemplateSpec<AdCountdownTemplateSpec>
{
  private _countdown = 0;
  private _isPreroll = false;

  private _Countdown = this.getByRef('Countdown')!;

  get announce() {
    const countdownLabel = this.getCountdownLabel();
    const countdownValue = getVideoTimeTts(formatVideoTime(this._countdown));
    if (countdownValue) {
      return `${countdownLabel} ${countdownValue}`;
    }
  }

  get countdown() {
    return this._countdown;
  }

  set countdown(countdown: AdCountdownTemplateSpec['countdown']) {
    this._countdown = countdown < 0 ? 0 : countdown;
    this.updateCountdown();
  }

  get isPreroll() {
    return this._isPreroll;
  }

  set isPreroll(isPreroll: AdCountdownTemplateSpec['isPreroll']) {
    this._isPreroll = isPreroll;
    this.updateCountdown();
  }

  static override _template(): Lightning.Component.Template<AdCountdownTemplateSpec> {
    return {
      rect: true,
      flex: {
        direction: 'row',
        alignItems: 'center',
        paddingLeft: 36,
        paddingRight: 34,
        paddingTop: 16,
        paddingBottom: 14,
      },
      shader: { type: Lightning.shaders.RoundedRectangle, radius: 11 },
      color: Colors('background').alpha(0.7).get(),
      Countdown: {
        type: TextLabel,
        text: {
          fontSize: FONT_SIZE,
          advancedRenderer: true,
        },
      },
    };
  }

  handleAnnounce() {
    Registry.setTimeout(() => {
      this.fireAncestors('$announce', this.announce, { append: true });
    }, ANNOUNCE_DELAY);
  }

  private getCountdownLabel() {
    if (this.isPreroll) {
      return translate('playback.adCountPrerollLabel');
    } else {
      return translate('playback.adCountLabel');
    }
  }

  private updateCountdown() {
    const countdownLabel = this.getCountdownLabel();
    const countdownValue = `<b>${formatVideoTime(this._countdown)}</b>`;
    this._Countdown.patch({
      text: {
        text: `${countdownLabel} ${countdownValue}`,
      },
    });
  }
}
